<template>
  <div>
    <net-pa-card v-if="$store.state.renderComponent">
      <template v-slot:header>
        <h6><i class="fas fa-credit-card ml-2"></i>لینک پرداخت تسهیلات</h6>
      </template>
      <template v-slot:content>
        <div class="row">
          <!-- {{ rows }} -->
          <div class="col-md-4 col-12">
            <div class="border bnp-rounded p-0 text-center bg-dark text-light" id="Information">
              <div class="row">
                <div class="col-12 text-center p-1 pt-2">
                  <h6 class="font-weight-bold text-light"><i class="fas fa-circle font-weight-bold text-warning ml-2"></i>اطلاعات واریز کننده</h6>
                </div>
                <div class="col-2"></div>
                <div class="col-8">
                  <input type="text" class="form-control required text-center" placeholder="نام و نام خانوادگی" :value="FullName" @input="onFullNameInput" />
                </div>
                <div class="col-2"></div>
                <div class="col-2"></div>
                <div class="col-8 mt-2 mb-3">
                  <input type="number" class="form-control required text-center" placeholder="شماره تلفن" @keypress="$ValidNumber($event,11)" v-model="Mobile"/>
                </div>
                <div class="col-2 "></div>
              </div>
            </div>
            <div class="border bnp-rounded p-0 text-center bg-dark text-light">
              <div class="row">
                <div class="col-12 text-center p-1 pt-2">
                  <h6 class="font-weight-bold text-light"><i class="fas fa-circle font-weight-bold text-warning ml-2"></i>اطلاعات تســـهیلات</h6>
                </div>
                <div class="col-12" style="min-height: 24vh">
                  <div class="row">
                    <div class="col-12 mt-1">
                        <h6 class="text-warning">{{ TotalFastPay.NameFam }}</h6>
                    </div>
                    <div class="col-12 text-center mt-2 mx-2">
                      <span class="text-light">مبلغ قابل پرداخت بابت </span>
                      <span class="text-warning" style="font-size: 15px">{{ TotalFastPay.VamCoutFastPay }}</span>
                      <span class="text-light"> {{ $GetIsAnbohSaz() == 'false' ? 'وام' : 'پروژه' }} </span>
                    </div>
                    <div class="col-12 text-center mt-1 mx-2">
                      <span class="text-light">مبلغ جریمه </span>
                      <span class="text-danger" style="font-size: 15px">{{ $Comma3ragham(TotalFastPay.SumJarmieFastPay) }}</span>
                    </div>
                    <div class="col-12 text-center mt-1">
                      <span class="text-light"> مبلغ قابل پرداخت: </span>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-6 mt-2 text-center">
                      <label style="font-size: 20px" class="border-bottom boroder-light">{{ $Comma3ragham(TotalFastPay.SumMabFastPay + '') }}</label>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-12 text-center tex-light my-1">
                      <span class="text-light">{{ $Mab2persianRial(TotalFastPay.SumMabFastPay + '') }}</span>
                    </div>

                    <div class="col-3 mt-1"></div>
                    <div class="col-6 mt-1">
                      <button class="bnp-rounded text-light btn w-100 mb-1" :disabled="TotalFastPay.SumMabFastPay == 0" @click="Pay" style="background: #435ebe !important">&nbsp; پرداخت {{ $Comma3ragham(TotalFastPay.SumMabFastPay + '') }} ریال &nbsp;</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 mt-md-0 mt-2 col-12" style="max-height: 220px; overflow-y: scroll">
            <div class="row">
              <div v-for="(item, index) in rows" :key="index" class="col-12 border-right border-success Netpa-Shadow-Local bg-white p-1 mt-2 px-4">
                <div class="row">
                  <div class="col-12 text-center mt-md-0 mt-2 text-md-right col-md-4">
                    <span v-if="$GetIsAnbohSaz() != 'false'" class="text-secondary">نام پروژه: </span>
                    <span v-else class="text-secondary">نام تسهیلات: </span>
                    <br />
                    <span class="no-wrap text-dark font-weight-bold">{{ item.desNoe }}</span>
                  </div>
                  <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                    <span v-if="$GetIsAnbohSaz() != 'false'" class="text-secondary">شماره قرارداد</span>
                    <span v-else class="text-secondary">شماره تسهیلات</span>
                    <br />
                    <span class="no-wrap text-dark font-weight-bold" dir="rtl">{{ item.vCode }}</span>
                  </div>
                  <!-- <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                    <span class="text-secondary">تاریخ قسط</span><br />
                    <span class="no-wrap text-dark font-weight-bold" dir="rtl">{{ item.minTarGhestBedehkar }}</span>
                  </div> -->
                  <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                    <span class="text-secondary">مبلغ قابل پرداخت</span><br />
                    <span class="text-dark font-weight-bold" dir="rtl">{{ $Comma3ragham(item.sumGhabelPar + '') }}</span>
                  </div>
                  <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                    <span class="text-secondary">مبلغ جریمه</span><br />
                    <span class="text-danger font-weight-bold" dir="rtl">{{ item.wwwjarime == null ? 0 : $Comma3ragham(item.wwwjarime + '') }}</span>
                  </div>
                  <div class="col-6 mt-md-0 mt-2 mb-2 text-center col-md-1" dir="rtl">
                    <span class="">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" :checked="rows[index].Active" v-model="rows[index].Active" :id="rows[index].vCode + 'active'" />
                        <label class="custom-control-label mt-2 Pointer" :for="rows[index].vCode + 'active'">انتخاب</label>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>
    <loading v-if="loadingRender"></loading>
  </div>
</template>

<script>
import Loading from '../Tools/NetPa/Loading.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
export default {
  components: { NetPaCard, Loading },
  data() {
    return {
      appsettings: {},
      loading: false,
      loadingRender: false,
      BnpCashDBtblAzaId: null,
      rows: [],
      SumJarmieFastPay: 0,
      Dargah: null,
      SumMablagh: 0,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      FullName:'',
      Mobile:null
    }
  },
  mounted() {
    if (!this.$route.query.aId) {
      this.$router.push({ name: 'LoginPage' })
    }
    
  },
  created() {
    this.getAppSetting()
  },
  methods: {
    stripPayerNameForSend(str) {
      return (str == null ? '' : String(str)).replace(/['"]/g, '')
    },
    onFullNameInput(e) {
      this.FullName = this.stripPayerNameForSend(e.target.value)
    },
    getAppSetting() {
      var axios = require('axios')
      var config = {
        method: 'GET',
        url: '/appSettings.json?nocache=123',
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
          'Content-Type': 'application/json',
        },
      }
      axios(config).then((result) => {
        this.appsettings = result.data
        //this.$cookies.set('IsAnbohSaz', this.appsettings.IsAnbohSaz)
        this.gettblCustomer()
      })
    },
    gettblCustomer() {
      this.loadingRender = true
      var settings = {
        method: 'Post',
        url: this.$GetapiBase()+ 'Setting',
        headers: {},
        data: null,
      }
      var axios = require('axios')
      //   console.log('settings',settings);
      axios(settings).then((result) => {
        this.$PostData({
          ArryfildValue: {},
          Action: 'GetTblCustomer',
          method: 'GET',
          Token: '',
        })
          .then((data) => {
            // console.log('dataaa',data);
            this.$store.state.NameSandogh = data.name
            this.$session.set('NameSandogh', data.name)
            this.$session.set('CustCode', data.custCode)
            document.title = ' خدمات الکترونیکی ' + data.name
            this.loadingRender = false
            this.CheckupLinkPay()
          })
          .catch(function (error) {
            console.log(error)
          })
      })
    },
    CheckupLinkPay() {     
      if (this.$route.query.aId) {
        if (this.$route.query.aId != null) {
          if (this.$GetIsLinkPay()) {
            this.loadingRender = true
            this.BnpCashDBtblAzaId = this.$route.query.aId.slice(0, -4)
            this.GetTaahodatForPayment()
          } else {
            this.$mySweetDefaultTost('خطا', 'سامانه واریز با لینک پرداخت برای شما فعال نگریدیده ، لطفا با مدیریت ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' هماهنگ کنید', 'error', 8000)
            this.$router.push({ name: 'LoginPage' })
            this.loadingRender = true
          }
        } else {
          this.$mySweetDefaultTost('خطای آدرس', 'لینک وارد شده صحیح نمی باشد ', 'error', 8000)
          this.$router.push({ name: 'LoginPage' })
          return
        }
      } else {
        // خطای نداشتن اعضا ایدی
        this.$mySweetDefaultTost('خطای URL', 'لینک وارد شده صحیح نمی باشد ', 'error', 8000)
          this.$router.push({ name: 'LoginPage' })
          return
      }
    },
    GetTaahodatForPayment() {
      this.loadingRender = true
      let DataAxiosRow = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/GetTaahodat',
        Token: this.$session.get('TokenNetPa'),
      }

      const formData = new FormData()
      formData.append('BnpCashDBtblAzaId', this.BnpCashDBtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 1)
      DataAxiosRow.ArryfildValue = formData
      this.$PostFormData(DataAxiosRow).then((data) => {
        if (data.status && data.status == false) {
          // خطا پیدانکردن عضو
          this.$mySweetDefaultTost('خطا', 'عضو مورد نظر یافت نشد', 'error', 8000)
          this.$router.push({ name: 'LoginPage' })
          return
        }
        let Result=JSON.parse(JSON.stringify(data))
          if(Result.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0).length>0)
        this.EditRows(Result.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0))
      else
      this.$mySweetDefaultTost('خطا', 'تسهیلاتی برای این شخص یافت نشد', 'error', 8000)

      })
    },
    EditRows(data) {
      
      let info
      let list = []
      for (let index = 0; index < data.length; index++) {
          info = data[index]
          info.SumGhabelPar = info.sumGhabelPar
        info['NewMande'] = info.mande - info.sumMabTaeedNaShode
        info.Active = true
        this.SumJarmieFastPay += info.wwwjarime == null ? 0 : info.wwwjarime
        list.push(info)
      }
      
      this.rows = list
      this.$store.state.renderComponent = false
      window.dispatchEvent(new Event('resize'))
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
      })
      this.loadingRender = false
    },
    Pay() {
        //console.log(this.TotalFastPay.listFastpay);
        
        if (!this.$ValidForm('Information')) {
            return;
        }
        if (this.Mobile.length<11) {
            this.$mySweetDefaultTost('هشدار','شماره موبایل وارد شده صحیح نمی باشد ، لطفا شماره موبایل را به فرمت صحیح وارد نمایید','warning',3000)
            return;
        }
      // this.Dargah==null
      if (false) {
        if (this.$session.get('CustCode') == 801) {
          this.$swal(
            'اختلال در پرداخت با درگاه',
            'مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)',
            'warning'
          )
        } else {
          this.$mySweetDefaultTost('عدم انتخاب درگاه', 'درگاهی برای سامانه تنظیم نشده است', 'warning', 3000)
        }
      } else {
        const WwwtblVarizGorohiRiz = []
        for (let index = 0; index < this.TotalFastPay.listFastpay.length; index++) {
          WwwtblVarizGorohiRiz.push({
            WwwtblTaahodatId: this.TotalFastPay.listFastpay[index].id,
            Mablagh: this.TotalFastPay.listFastpay[index].sumGhabelPar,
            SharhRiz: ' پرداخت از لینک پرداخت با کد ملی قسط تسهیلات ' + this.TotalFastPay.listFastpay[index].vCode,
            WwwtblAzaId: this.TotalFastPay.listFastpay[index].wwwtblAzaId,
            BnpCashDBtblTaahodatId: this.TotalFastPay.listFastpay[index].bnpCashDBtblTaahodatId,
            BnpCashDBtblAzaId: this.$route.query.aId.slice(0, -4),
            MablaghJarime: this.TotalFastPay.listFastpay[index].wwwjarime == null ? 0 : this.TotalFastPay.listFastpay[index].wwwjarime,
            TarixGhest: this.TotalFastPay.listFastpay[index].minTarGhestBedehkar,
          })
        }
        this.SumMablagh = this.TotalFastPay.SumMabFastPay
        this.DataAxios_Variz.ArryfildValue.Mablagh = this.SumMablagh
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$GetJalaliDate()
        this.DataAxios_Variz.ArryfildValue.Sharh = 'پرداخت اقساط گروهی'
        this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$GetJalaliDate()
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('CustCode'))
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = this.TotalFastPay.listFastpay[0].wwwtblAzaId
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
        // console.log(this.DataAxios_Variz.ArryfildValue)
        this.$PostData(this.DataAxios_Variz).then((result) => {
          const nameForSend = this.stripPayerNameForSend(this.FullName)
          this.$Payment(
            JSON.stringify(this.Dargah),
            JSON.stringify(this.SumMablagh),
            nameForSend,
            'linkpay',
            this.Mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            '0',
            this.TotalFastPay.listFastpay[0].vCode,
            'لینک پرداخت - سبد اقساط',
            this.TotalFastPay.listFastpay[0].wwwtblAzaId+'',
            this.$session.get('CustCode')+'',
            this.TotalFastPay.listFastpay[0].wwwtblShobeId+'',
            result.idRepoMaster,
            this.TotalFastPay.listFastpay[0].codeMeli,
            this.TotalFastPay.listFastpay[0].nameFamily,
            this.TotalFastPay.listFastpay[0].mobile,
            this.TotalFastPay.listFastpay[0].codeMeli
          )
        })
      }
    },
    GetGateway(wwwtblShobeId){
      this.$GatewayOld(wwwtblShobeId).then((data) => {
      if (data.status == 'Ok') {
        data.data.forEach((element) => {
          if ((element.gatewayCode != null || element.gatewayCode != '') && element.isDefault == true) {
            this.Dargah = element.id
          }
        })
      } else {
        this.$mySweetDefaultTost('عدم وجود اطلاعات', data.msg, 'warning', 2000)
        this.$router.push({ name: 'LoginPage' })
      }
    })
    }
  },
  computed: {
    TotalFastPay() {
      var shomarande = 0
      var SumMabFastPay = 0
      var VamCoutFastPay = 0
      var SumJarmieFastPay = 0
      var NameFam = ''
      var listFastpay = []
      for (let index = 0; index < this.rows.length; index++) {
        const element = this.rows[index]

        if (element.Active) {
          shomarande++
          SumMabFastPay += element.sumGhabelPar
          SumJarmieFastPay += element.wwwjarime == null ? 0 : element.wwwjarime
          NameFam=element.nameFamily
          listFastpay.push(element)
        }
      }
      // console.log(this.rows[0].wwwtblShobeId);
      this.GetGateway(this.rows[0].wwwtblShobeId)
      
      VamCoutFastPay = shomarande
      return {
        VamCoutFastPay: VamCoutFastPay,
        SumJarmieFastPay: SumJarmieFastPay,
        SumMabFastPay: SumMabFastPay,
        listFastpay: listFastpay,
        NameFam:NameFam
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.border-success {
  border-right: #394fc7 solid 3px !important;
  // border-bottom: #394fc7 dashed 1px !important;
}
.Netpa-Shadow-Local {
  -webkit-box-shadow: 0px 9px 29px -4px rgba(138, 138, 138, 1);
  -moz-box-shadow: 0px 9px 29px -4px rgba(138, 138, 138, 1);
  box-shadow: 0px 9px 29px -4px rgba(138, 138, 138, 1);
}
</style>
